var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterInstagramLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.91406C9.78864 8.91406 7.99255 10.7101 7.99255 12.9214C7.99255 15.1326 9.78864 16.9331 11.9999 16.9331C14.2111 16.9331 16.0116 15.1326 16.0116 12.9214C16.0116 10.7101 14.2111 8.91406 11.9999 8.91406Z",
    fill: "#CBD1D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0481 1.99805H5.95179C3.26422 1.99805 1.07483 4.18744 1.07483 6.87501V18.9713C1.07483 21.6632 3.26422 23.8482 5.95179 23.8482H18.0481C20.74 23.8482 22.925 21.6632 22.925 18.9713V6.87501C22.925 4.18744 20.74 1.99805 18.0481 1.99805ZM11.9999 20.0026C8.09748 20.0026 4.92046 16.8256 4.92046 12.9231C4.92046 9.0207 8.09748 5.84805 11.9999 5.84805C15.9024 5.84805 19.0794 9.0207 19.0794 12.9231C19.0794 16.8256 15.9024 20.0026 11.9999 20.0026ZM19.228 7.13284C18.402 7.13284 17.729 6.46423 17.729 5.63829C17.729 4.81235 18.402 4.13937 19.228 4.13937C20.0539 4.13937 20.7269 4.81235 20.7269 5.63829C20.7269 6.46423 20.0539 7.13284 19.228 7.13284Z",
    fill: "#CBD1D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstagramLight);
export default __webpack_public_path__ + "static/media/FooterInstagramLight.4531e3aafb8aac8477252a9b4efa742d.svg";
export { ForwardRef as ReactComponent };